import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PagerService } from '../../common/pagerService';
@Component({
    selector: 'custom-pagenation',
    templateUrl: './pagenation.html',

})

export class CustomPager {
    @Input()
    pager: any = {};
    @Input()
    isNoRecords: boolean = true;

    @Output() pageClick = new EventEmitter();


    setPage(page: number) {
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        else {
            //this.pageClick.emit(page);
            this.pager.pageIndex = page - 1;
            this.pageClick.emit(this.pager);
        }

    }

    setPageSize(pageSize: number) {
        this.pager.pageSize = pageSize;
        this.setPage(this.pager.pageIndex);
    }

}
